import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import AutoQuery from 'servicestack/auto-query/auto-query'
import $session from 'servicestack/session'
import cartConfig from "emun.cart/cart.config";
import customerConfig from "emun.customer/customer.config";

class ViewBadgeController {
    constructor($rootScope, $uibModalInstance, options) {
        var $ctrl = this;
        basicController($ctrl);
		console.debug("BL*** options", options);
		$ctrl.badge = options.model.badge.data;
		$ctrl.provider = options.model.badge.provider;
		$ctrl.badgeRoot = options.model.badge;
		console.debug("BL*** badge", $ctrl.badge);
		var bus = $ctrl.bus = new ServiceBus($rootScope);
		$ctrl.$uibModalInstance = $uibModalInstance;
		$ctrl.config = cartConfig;
		$ctrl.customerConfig = customerConfig;
        $ctrl.title = options.title || 'Badge...';
	}
	$onInit() {
		const $ctrl = this;
	}
	dismiss(reason) {
		let $ctrl = this;
		$ctrl.$uibModalInstance.dismiss(reason);
	}
}

export default ViewBadgeController;